import axios from 'axios';
import Frame from '../../store/interfaces/frame.interface';

interface ResponseCallback {
  onSuccess?: (res: any) => void;
  onError?: (err: any) => void;
}

interface Filter {
  gender: string;
  pageNum: number;
  pageCount: number;
  sortBy: any;
  sortDir: any;
}

type hookType = {
  getAllFrames: (params: ResponseCallback, filter: Filter) => void;
  getFrameByCode: (callback: ResponseCallback, modelCode: any) => void;
};

const useProducts = (): hookType => {
  const getAllFrames = (callback: ResponseCallback, filter: Filter) => {
    const { onSuccess, onError } = callback;

    // https://test.transitions.com/vtoapi/api/VAframes?colors=1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21&brands=1,2,3,4,5,6,7,8,9,10,11&genders=1,2,3&styles=1,2,3,4
    axios
      .get<Frame[]>('/frames-temp.json')
      .then(res => {
        if (onSuccess) {
          if (res.status === 200) {
            const { gender, pageCount, pageNum, sortBy, sortDir } = filter;
            let frames = res.data;

            if (gender !== 'all') {
              frames = frames.filter(i => i.genderName === gender);
            }

            if (sortBy !== '') {
              frames = frames.sort((a, b) => {
                if (a[sortBy] < b[sortBy]) return sortDir === 'asc' ? -1 : 1;
                else if (a[sortBy] > b[sortBy]) return sortDir === 'asc' ? 1 : -1;

                return 0;
              });
            }

            const frameLength = frames.length;
            const frameStartIndex = pageNum * pageCount;

            let paginationCount = frameLength / pageCount;
            paginationCount =
              parseInt(paginationCount.toString()) + (paginationCount % 1 > 0 ? 1 : 0);

            let frameEndIndex = frameStartIndex + pageCount;

            if (frameEndIndex >= frameLength) frameEndIndex = frameLength;

            frames = frames.slice(0, frameEndIndex);

            setTimeout(
              () => {
                onSuccess({ paginationCount, frames, pageNum });
              },
              frameStartIndex === 0 ? 0 : 2000,
            );
          } else {
            onSuccess({ paginationCount: 0, pageNum: 0, frames: [] });
          }
        }
      })
      .catch(err => onError && onError(err));
  };

  const getFrameByCode = (callback: ResponseCallback, modelCode: any) => {
    const { onSuccess, onError } = callback;

    axios
      .get<Frame[]>('/frames-temp.json')
      .then(res => {
        if (onSuccess) {
          if (res.status === 200) {
            let frames = res.data.filter(i => i.modelCode === modelCode);

            onSuccess(frames);
          } else {
            onSuccess([]);
          }
        }
      })
      .catch(err => onError && onError(err));
  };

  return {
    getAllFrames,
    getFrameByCode,
  };
};

export default useProducts;
